module.exports = __webpack_public_path__ + "common/icon-twitter-99c7930314ee454c7fe761f40d18e37c.svg";